import {
  createRootRoute,
  createRoute,
  createRouter,
  Outlet,
  redirect,
} from "@tanstack/react-router";
import { AppShell } from "./components/AppShell";
import { Dashboard } from "./pages/Dashboard";
import { EntityPage } from "./pages/EntityPage";
import { SeatingPage } from "./pages/SeatingPage";
import { SchedulePage } from "./pages/SchedulePage";
import { RsvpPage } from "./pages/SystemPages";
import { AuditPage } from "./pages/AuditPage";
import { SettingsPage } from "./pages/SettingsPage";
import { WorkspacesPage } from "./pages/WorkspacesPage";

const root = createRootRoute({ component: () => <Outlet /> });
const index = createRoute({
  getParentRoute: () => root,
  path: "/",
  beforeLoad: () => {
    throw redirect({ to: "/workspaces" });
  },
});
const workspaces = createRoute({
  getParentRoute: () => root,
  path: "/workspaces",
  component: WorkspacesPage,
});
const rsvp = createRoute({
  getParentRoute: () => root,
  path: "/rsvp/$token",
  component: RsvpPage,
});
const workspace = createRoute({
  getParentRoute: () => root,
  path: "/w/$workspaceId",
  component: AppShell,
});
const dashboard = createRoute({
  getParentRoute: () => workspace,
  path: "dashboard",
  component: Dashboard,
});
const seating = createRoute({
  getParentRoute: () => workspace,
  path: "seating",
  component: SeatingPage,
});
const schedule = createRoute({
  getParentRoute: () => workspace,
  path: "day-schedule",
  component: SchedulePage,
});
const audit = createRoute({
  getParentRoute: () => workspace,
  path: "audit",
  component: AuditPage,
});
const settings = createRoute({
  getParentRoute: () => workspace,
  path: "settings",
  component: SettingsPage,
});
const section = createRoute({
  getParentRoute: () => workspace,
  path: "$section",
  component: EntityPage,
  validateSearch: (search: Record<string, unknown>) => ({
    ...(typeof search.status === "string" ? { status: search.status } : {}),
    ...(typeof search.attendance === "string"
      ? { attendance: search.attendance }
      : {}),
    ...(typeof search.riskLevel === "string"
      ? { riskLevel: search.riskLevel }
      : {}),
    ...(typeof search.paymentStatus === "string"
      ? { paymentStatus: search.paymentStatus }
      : {}),
    ...(typeof search.view === "string" ? { view: search.view } : {}),
    ...(typeof search.record === "string" ? { record: search.record } : {}),
  }),
});
const routeTree = root.addChildren([
  index,
  workspaces,
  rsvp,
  workspace.addChildren([
    dashboard,
    seating,
    schedule,
    audit,
    settings,
    section,
  ]),
]);
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
});
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
